var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPostIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6226_12338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.000156498 14.534C0.0148435 15.0301 0.0598435 15.4003 0.0823435 15.578C0.112344 15.7631 0.284844 15.9482 0.479843 15.9852C0.509843 15.9852 0.539843 15.9926 0.569843 15.9926C0.742343 15.9926 0.907344 15.9037 0.997344 15.7557C4.40984 10.1212 9.44234 10.373 11.0323 10.6099V14.4303C11.0323 14.6154 11.1523 14.7857 11.3248 14.8524C11.4973 14.919 11.6998 14.8746 11.8273 14.7413L17.5423 8.61082C18.1573 7.95187 18.1423 6.93752 17.5198 6.29337L11.5498 0.140666C11.4223 0.00739432 11.2198 -0.0370295 11.0473 0.0370103C10.8748 0.103646 10.7623 0.273938 10.7623 0.459037V4.19805C10.0498 4.19805 9.43484 4.27949 8.81984 4.36834C3.66734 5.0495 -0.120156 9.43266 -0.000156498 14.534ZM11.6773 4.64229V1.57704L16.8673 6.91531C17.1598 7.21147 17.1673 7.68532 16.8823 7.99629L11.9698 13.2753V10.2397C11.9698 10.0324 11.8273 9.84728 11.6173 9.80286C11.6173 9.80286 10.9198 9.63997 9.83984 9.63997C7.76234 9.63997 3.87734 10.2471 0.929844 14.2527C0.959844 9.71401 4.36484 5.87875 8.95484 5.25682C9.71984 5.15316 10.3648 5.07912 11.2198 5.10133H11.2273C11.3548 5.10133 11.4598 5.06431 11.5498 4.97546C11.6398 4.88662 11.6923 4.77556 11.6923 4.64969L11.6773 4.64229Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6226_12338"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 16,
    rx: 6,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostIcon);
export default __webpack_public_path__ + "static/media/postIcon.2f47e28f126f2eeda7fa7dcc07deec5e.svg";
export { ForwardRef as ReactComponent };